import { Knex } from 'knex';
import HomeController from '@/components/explore/HomeController';
import { GeniusDB } from '@/core/db-connection';
type HomePageProps = {
  userName: string;
};
export async function getServerSideProps(context) {
  const {
    query
  } = context;
  const code = query.code;
  const db: Knex = GeniusDB();
  if (code) {
    // eth_address is uppercase in referral table and lowercase in cloudwallets table lol
    const referringUser = await db('referral_codes').select('*').where('referral_code', code).first();
    const ethAddress = referringUser?.eth_address;
    const cloudWallet = await db('cloud_wallets').select('*').whereRaw('LOWER(eth_address) = ?', [ethAddress.toLowerCase()]).first();
    const userName = cloudWallet?.username;
    return {
      props: {
        userName
      }
    };
  } else {
    return {
      props: {
        userName: ''
      }
    };
  }
}
export default function HomePage(props: HomePageProps) {
  return <HomeController userName={props?.userName} data-sentry-element="HomeController" data-sentry-component="HomePage" data-sentry-source-file="index.tsx" />;
}